class Sofatutor.Classes.Press
  constructor: ->
    @cache()
    @bindEvents()
    @showPressReleaseCards()
    @initCarousel()
    new Foundation.Accordion(@$downloadsAccordion)
    new Foundation.Magellan(@$navigationList)

  cache: ->
    @$expandAboutTextButton = $('.js-expand-text')
    @$expandedAboutText     = $('.js-extended-text')
    @$hideAboutTextButton   = $('.js-hide-text')
    @$expandFactsButton     = $('.js-expand-facts')
    @$factsList             = $('.press-facts-list')
    @$expandedFacts         = $('.js-expand-facts')
    @$hideFactsButton       = $('.js-hide-facts')
    @$navigationList        = $('.press-navigation__list')
    @$downloadsAccordion     = $('.press-downloads-accordion')

  bindEvents: ->
    @$expandAboutTextButton.on 'click', () =>
      @$expandedAboutText.toggleClass('is-hidden')
      @$expandAboutTextButton.hide()

    @$hideAboutTextButton.on 'click', () =>
      @$expandedAboutText.toggleClass('is-hidden')
      @$expandAboutTextButton.show()
      new Sofatutor.Classes.ScrollHelper().animateScroll('.press-about__headline', 0, 200)

    @$expandFactsButton.on 'click', () =>
      @$expandFactsButton.hide()
      @$factsList.toggleClass('collapsed')
      @$hideFactsButton.toggleClass('is-hidden')

    @$hideFactsButton.on 'click', () =>
      new Sofatutor.Classes.ScrollHelper().animateScroll('.press-facts-list', 0, 200)
      @$factsList.toggleClass('collapsed')
      @$expandFactsButton.hide()

  showPressReleaseCards: ->
    press_cards = $('.press-release-card').length
    x = 3
    $('.press-release-card:lt(' + x + ')').show()
    $('.js-load-more-articles').click ->
      x = if x + 5 <= press_cards then x + 5 else press_cards
      $('.press-release-card:lt(' + x + ')').show()
      if x == press_cards
        $('.js-load-more-articles').hide()

  initCarousel: ->
    $('.js-press-quotes-carousel').slick(
      dots: true,
      slidesToShow: 1,
      infinite: true,
      arrows: true,
      prevArrow: '<button class="press-quotes__previous-arrow" aria-label="Zurück"><i class="icon icon--arrow-thin icon--rotate-left icon--large"></i></button>'
      nextArrow: '<button class="press-quotes__next-arrow" aria-label="Weiter"><i class="icon icon--arrow-thin icon--large"></i></button>'
      responsive: [
        {
          breakpoint: 959
          settings:
            arrows: false
        }
      ]
    )

$ ->
  return unless $('body').is('.press-page')
  new Sofatutor.Classes.Press
